"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getFieldValidationInfo;
/**
 * Searches for a field within the validation information based on provided page code, section code, field code, and optional row ID.
 * Returns the errors and warnings for the specified field.
 *
 * @param {Object} validationInfo - The validation information to search through.
 * @param {string} pageCode - The code of the page the field belongs to.
 * @param {string} sectionCode - The code of the section the field belongs to.
 * @param {string} fieldCode - The code of the field to find.
 * @param {string} [rowId] - Optional. The row ID of the section the field belongs to.
 *
 * @returns {Object} An object containing two properties: `errors` and `warnings`. Each is an array of error or warning objects for the specified field. If no matching field is found, returns empty arrays.
 *
 * @example
 * const result = getFieldErrorsWarnings(validationInfo, 'pageCode', 'sectionCode', 'fieldCode', 'rowId');
 * console.log(result.errors); // Logs the errors for the specified field
 * console.log(result.warnings); // Logs the warnings for the specified field
 */
function getFieldValidationInfo(validationInfo, pageCode, sectionCode, fieldCode, rowId) {
    var errors = [];
    var warnings = [];

    if (validationInfo && validationInfo.pages) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = validationInfo.pages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var page = _step.value;

                if (page.code === pageCode && page.sections) {
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = page.sections[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var section = _step2.value;

                            if (section.code === sectionCode && (!rowId || section.rowId && section.rowId === rowId) && section.fields) {
                                var _iteratorNormalCompletion3 = true;
                                var _didIteratorError3 = false;
                                var _iteratorError3 = undefined;

                                try {
                                    for (var _iterator3 = section.fields[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                        var field = _step3.value;

                                        if (field.code === fieldCode) {
                                            if (field.errors) {
                                                errors = field.errors;
                                            }
                                            if (field.warnings) {
                                                warnings = field.warnings;
                                            }
                                            // Once the field is found, there's no need to continue searching
                                            return { errors: errors, warnings: warnings };
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError3 = true;
                                    _iteratorError3 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                            _iterator3.return();
                                        }
                                    } finally {
                                        if (_didIteratorError3) {
                                            throw _iteratorError3;
                                        }
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }

    // If no matching field is found, return empty arrays
    return { errors: errors, warnings: warnings };
}